import { twMerge } from "tailwind-merge";

import { SmallTitle } from "@/components/text/SmallTitle";

export function SliderDisplayNumber({
  value,
  decimalToPercent,
  className,
}: {
  value: number;
  decimalToPercent: boolean;
  className?: string;
}) {
  return (
    <SmallTitle
      elementType="span"
      className={twMerge(
        "w-14 rounded-lg bg-gray-200 py-1 text-center",
        className
      )}
    >
      {decimalToPercent ? `${Math.round(value * 100)}%` : value}
    </SmallTitle>
  );
}
